import { OnInit, TemplateRef, ViewChild, Output, EventEmitter } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { DataManager } from '@syncfusion/ej2-data';
import { PageSettingsModel } from '@syncfusion/ej2-grids';
import { ApiGridParameters, CrawfordApiGridAdaptor, CrawfordDialogComponent, CrawfordGridComponent,
  CrawfordSnackbarService, DateFormat, GridColumn, ITabComponent } from 'crawford-shell';
import { ClaimService } from '../claim/claim.service';
import { AdvancedSearch } from '../claim/model/advanced-search.model';
import { UserDetails } from '../user/user-details.model';
import { UserService } from '../user/user.service';
import { SavedSearch } from './model/saved-search.model';
import { SavedSearchService } from './saved-search.service';

export abstract class BaseSearchListComponent implements OnInit, ITabComponent {

  @Output() searchListChanged: EventEmitter<void> = new EventEmitter<void>();

  @ViewChild('ccoGrid') public ccoGrid: CrawfordGridComponent;
  @ViewChild('templateRetrieveBtn') public templateRetrieveBtnRef: TemplateRef<any>;
  @ViewChild('templateDeleteBtn') public templateDeleteBtnRef: TemplateRef<any>;
  @ViewChild('deleteDialog') public deleteDialog: CrawfordDialogComponent;

  public dataLoaded = false;
  public adaptor: CrawfordApiGridAdaptor;
  public dataSource: DataManager;
  public userDetails: UserDetails;
  public savedSearch: SavedSearch = new SavedSearch();
  public headerText = 'Saved Searches';

  public df: DateFormat = {
    type: 'datetime',
    format: 'dd/MM/yyyy HH:mm'
  };

  public displayColumns: GridColumn[] = [];
  public columnsToAutoFit: string[] = [];
  public sortingSettings: any;
  public pageSettings: PageSettingsModel = {
    pageSize: 10
  };

  constructor(
    protected router: Router,
    protected savedSearchService: SavedSearchService,
    protected snackbarService: CrawfordSnackbarService,
    protected activatedRoute: ActivatedRoute,
    protected userService: UserService,
    protected claimService: ClaimService
  ) {
  }

  public ngOnInit(): void {
    this.userDetails = this.userService.userDetails;
    this.buildGridColumns();
    this.buildSortSettings();
    this.adaptor = this.initalizeAdaptor();
  }

  public abstract loadData(): void;

  public refreshGrid(): void {
    this.ccoGrid.refresh();
  }

  protected initalizeAdaptor(): CrawfordApiGridAdaptor {
    const parameters = new ApiGridParameters();
    parameters.top = this.pageSettings.pageSize;
    parameters.orderBy.columnName = this.sortingSettings.columns[0].field;
    parameters.orderBy.direction = this.sortingSettings.direction;

    return new CrawfordApiGridAdaptor(parameters);
  }

  protected abstract buildGridColumns(): void;

  protected buildSortSettings(): void {
    this.sortingSettings = {
      columns: [{ field: 'lastUsedDate', direction: 'descending' }]
    };
  }

  public deleteSavedSearch(data: SavedSearch) {
    this.savedSearch = data;
    this.deleteDialog.showDialog();
  }

  public onCancelDelete(event): void {
    const message = '\'' + this.savedSearch.searchName + '\' search has not been deleted';
    this.snackbarService.displayInfoMessage(message);
  }

  public onConfirmDelete(event): void {
    this.savedSearchService.deleteSavedSearch(this.savedSearch.id).subscribe(deleted => {
      if (deleted) {
        this.savedSearchService.resetRetrievedSearch(this.savedSearch.id);
        const message = 'Successfully deleted ' + this.savedSearch.searchName + ' for ' + this.savedSearch.userName;
        this.snackbarService.displaySuccessMessage(message);
        this.searchListChanged.emit();
      } else {
        this.snackbarService.displayErrorMessage('Failed to delete saved search ' + this.savedSearch.searchName);
      }
    });
  }

  public onDataBound($event: any): void {
    if ($event.totalRecordCount === 0) {
      this.headerText = 'No Saved Searches';
    } else {
      this.headerText = 'Saved Searches';
    }
  }

  public onRowDataBound($event): void {
  }

  public retrieveSavedSearch(search: SavedSearch) {
    this.savedSearchService.retrieveSavedSearchById(search.id).subscribe(searchWithData => {
      if (searchWithData) {
        this.savedSearch = searchWithData;
        const advancedSearch = new AdvancedSearch(JSON.parse(searchWithData.search));
        this.claimService.saveSearch(advancedSearch);
        this.savedSearchService.setRetrievedSearch(this.savedSearch);
        this.router.navigate(['claim/search']);
      }
    });
  }
}



// WEBPACK FOOTER //
// D:/a/1/s/UI/src/app/saved-search/base-search-list.component.ts